import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { MODULES, moduleHref, getCategory } from "@/lib/modules";
import { Container, Section, SectionHeader, Reveal } from "@/components/ui-kit";
import { BrowserFrame } from "@/components/mockups/primitives";
import { Mockup, PHONE_MOCKUPS } from "@/components/mockups";

export const NEW_MODULES = MODULES.filter((m) => m.isNew);

const NewModuleCard = ({ m, delay, wide }) => (
  <Reveal delay={delay} className={wide ? "md:col-span-2" : undefined}>
    <Link to={moduleHref(m)} data-testid={`new-module-${m.slug}`} className="card-dark group flex flex-col p-6 sm:p-7 h-full">
      <div className="flex items-center justify-between gap-3">
        <span className="inline-flex items-center gap-1.5 rounded-full border border-mk-lime/40 bg-mk-lime/10 px-2.5 py-1 font-mono text-[10px] uppercase tracking-wider text-mk-lime"><Sparkles className="h-3 w-3" />New · {getCategory(m.category).name}</span>
        <span className="font-mono text-[10px] text-mk-muted text-right hidden sm:inline">{m.demo ? <span className="text-mk-text" data-testid={`new-module-${m.slug}-live`}>Live demo on the page ↗</span> : m.kicker}</span>
      </div>
      <h3 className="mt-4 font-display text-2xl font-bold text-mk-text text-balance flex items-center gap-3"><span className="grid place-items-center h-9 w-9 rounded-xl border border-mk-border bg-mk-bg text-mk-lime shrink-0"><m.icon className="h-4.5 w-4.5" /></span>{m.name}</h3>
      <p className="mt-3 text-sm text-mk-dim leading-relaxed">{m.summary}</p>
      <div className="mt-6 relative">
        {PHONE_MOCKUPS.has(m.mockup) ? (
          <div className="py-2 flex justify-center pointer-events-none"><Mockup name={m.mockup} /></div>
        ) : (
          <BrowserFrame url={m.liveUrl?.replace("https://", "")} className="pointer-events-none"><Mockup name={m.mockup} compact /></BrowserFrame>
        )}
      </div>
      <div className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-mk-text group-hover:text-mk-lime transition-colors">Explore {m.name} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></div>
    </Link>
  </Reveal>
);

const NewModules = () => (
  <Section id="new" className="bg-mk-surface/40 border-y border-mk-border" data-testid="new-modules">
    <Container>
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
        <SectionHeader eyebrow="New this quarter" title="Properties, money, contractors, intake and safety — now in the engine." desc="Eight new modules: an H&S Template Library you can copy from and share back to, a Properties hub on one map, Accounts & Bookkeeping with bank feeds, MTD VAT and payroll, a vetted Contractor Marketplace, emails that become jobs, QR + NFC asset tags, AI-written RAMS and toolbox talks with signatures — plus a statutory calendar inside Compliance Hub." />
        <Link to="/product/compliance-hub" className="btn-ghost shrink-0 self-start lg:self-auto" data-testid="new-modules-compliance">Compliance Hub, expanded <ArrowRight className="h-4 w-4" /></Link>
      </div>
      <div className="mt-12 grid md:grid-cols-2 gap-6">
        {NEW_MODULES.map((m, i) => <NewModuleCard key={m.slug} m={m} delay={i * 0.07} wide={NEW_MODULES.length % 2 === 1 && i === NEW_MODULES.length - 1} />)}
      </div>
    </Container>
  </Section>
);

export default NewModules;
